module.exports = __webpack_public_path__ + "media/images/v1/1920_couple-e602dea51badfc4f958274264cdf2daf.png";